// import defaultList from "./defaultList";

const mutations = {
  setListPictures(state, listPictures) {
    state.listPictures = [...state.listPictures, ...listPictures];
  },
  clearListPictures(state) {
    state.listPictures = [];
  },

  uncheckAll(state) {
    state.listPictures = state.listPictures.map((picture) => {
      picture.checked = false;
      return picture;
    });
  },

  setPictureDetails(state, pictureDetails) {
    state.pictureDetails = pictureDetails;
  },
};

export default mutations;
